export default typeof URL !== 'undefined' ? URL : require('url').URL; // eslint-disable-line global-require
